import { NgModule } from '@angular/core';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { RouterModule, Routes, Router, RouterLink } from '@angular/router';
import { AuthGuard } from './guard/auth-guard';
import { LogoutComponent } from './components/logout/logout.component';
import { LoginGuard } from './guard/login-guard';

export const routes: Routes = [
  {
    path: '', redirectTo: 'login', pathMatch: 'full',
  },
  {
    path: '*', redirectTo: 'login', pathMatch: 'full'
  },
  {
    path: 'home', component: HomeComponent, pathMatch: 'full'
  },
  {
    path: 'login', component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'logout', component: LogoutComponent
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'customer',
    loadChildren: () => import('./modules/customer/customer.module').then(m => m.CustomerModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'insurer',
    loadChildren: () => import('./modules/insurer/insurer.module').then(m => m.InsurerModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'warehouse',
    loadChildren: () => import('./modules/warehouse/warehouse.module').then(m => m.WarehouseModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'shipping',
    loadChildren: () => import('./modules/shipping/shipping.module').then(m => m.ShippingModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'billing/insurance',
    loadChildren: () => import('./modules/billing-insurance/billing-insurance.module').then(m => m.BillingInsuranceModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'billing/private-customer',
    loadChildren: () => import('./modules/billing-private-customers/billing-private-customer.module').then(m => m.BillingPrivateCustomerModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'billing/customer',
    loadChildren: () => import('./modules/billing-customer/billing-customer.module').then(m => m.BillingCustomerModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'billing',
    loadChildren: () => import('./modules/billing/billing.module').then(m => m.BillingModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'preparation',
    loadChildren: () => import('./modules/preparation/preparation.module').then(m => m.PreparationModule),
    data: {
      roles: ['packer']
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'return-shipment',
    loadChildren: () => import('./modules/return-shipment/return-shipment.module').then(m => m.ReturnShipmentModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'delayed-shipments',
    loadChildren: () => import('./modules/delayed-shipments/delayed-shipments.module').then(m => m.DelayedShipmentsModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'private-customer',
    loadChildren: () => import('./modules/private-customer/private-customer.module').then(m => m.PrivateCustomerModule),
    data: {
      roles: ['system', 'admin']
    },
    canActivate: [AuthGuard]
  },
  {
    path: 'public',
    loadChildren: () => import('./modules/public/public.module').then(m => m.PublicModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})

export class AppRoutingModule { }
